/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unreachable */
import React, { useEffect, useState } from 'react';
import { Progress, Spin } from 'antd';
import { apiLaunchPad } from '../../../api/apiLaunchPad';
import { LoadingOutlined } from '@ant-design/icons';
import Countdown from "react-countdown";
import {
    rendererCountDown,
} from "../utilsIDO";
import { useNavigate } from 'react-router-dom';
import { formatNumber } from '../../../components/utils/FormatNumber';

const Item = ({ item }: any) => {

    const convertToTimestamp = (isoString: any) => {
        return isoString ? new Date(isoString).getTime() : null;
    };

    const timeStart: any = convertToTimestamp(item?.start_time);
    const timeEnd: any = convertToTimestamp(item?.end_time);
    const currentTime: any = new Date().getTime();

    const navigate = useNavigate();
    function goToDetail(id: any): void {
        navigate(`/launchpads/${id}`);
    }

    const percent_total = Number((item?.total_sold / item?.total_raise).toFixed(4)) * 100

    return (
        <>
            <div className="item-pj" onClick={() => goToDetail(item?.slug)}>
                <div className="line-top">
                    <img src="./images/line-top.png" alt="" />
                </div>
                <div className="line-bot">
                    <img src="./images/line-bot.png" alt="" />
                </div>
                <div className="left">
                    <div className="box-img-banner">
                        <img src={item?.background} alt="" />
                        <div className="text-ido">
                            {item?.campaign_type}
                        </div>
                    </div>
                </div>
                <div className="right">
                    <div className="guide-project">
                        <div className="wash-top">
                            <div className="title-pr">
                                <div className="box-img">
                                    <img src={item?.avatar} alt="" />
                                </div>
                                <div className="name-ido">
                                    {item?.title} <span>{item?.token?.symbol}</span>
                                </div>
                            </div>
                            <div className="chain-pr">
                                <div className="logo-chain">
                                    <img src={item?.token?.chain?.logo} alt="" />
                                    {item?.token?.chain?.name}
                                </div>
                            </div>
                        </div>
                        <div className="wash-center">
                            <ul className="list-info">
                                <li>
                                    <div className="txt-top">
                                        TOTAL RAISE
                                    </div>
                                    <div className="txt-bottom">
                                        {new Intl.NumberFormat("ja-JP", { maximumFractionDigits: 8 }).format(item?.total_raise)} {item?.currency?.symbol}
                                    </div>
                                </li>
                                <li>
                                    <div className="txt-top">
                                        Price
                                    </div>
                                    <div className="txt-bottom">
                                        {formatNumber(item?.price, 8)} {item?.currency?.symbol}
                                    </div>
                                </li>
                                <li>
                                    <div className="txt-top">
                                        {currentTime < timeStart || !timeStart ? "Starts In" : "Ends In"}:{" "}
                                    </div>
                                    <div className="txt-bottom custom">
                                        {timeStart ? <Countdown renderer={rendererCountDown} date={currentTime < timeStart ? timeStart : timeEnd} /> : "TBA"}
                                    </div>  
                                </li>
                            </ul>
                            <div className="process-ido">
                                <div className="top top-mobie">
                                    <div className="item">
                                        Progress: <span className='new-span'>{formatNumber(percent_total, 2)}%</span>
                                        {/* percent_total */}
                                    </div>
                                    <div className="item">
                                        <span className='span-cus'>Total Joined:</span>
                                        <span className="number">
                                            <span>{formatNumber(item?.total_sold, 8)}/</span>{new Intl.NumberFormat("ja-JP", { maximumFractionDigits: 8 }).format(item?.total_raise)} {item?.currency?.symbol}
                                        </span>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <Progress
                                        percent={percent_total}
                                        percentPosition={{ align: 'center', type: 'inner' }}
                                        size={['100%', 20]}
                                        strokeColor={{ from: '#3C8CE7', to: '#00EAFF' }}
                                    />
                                    {/* <Progress
                                        percent={percent_total}
                                        strokeWidth={12}
                                        className="striped-progress"
                                        showInfo={false}
                                    /> */}
                                </div>
                            </div>
                        </div>
                        {/* <div className="wash-bottom">
                            <button className="main-button w-150" onClick={() => goToDetail(item?.id)}>
                                Details
                            </button>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    )
}

const Opening = () => {
    const [loading, setLoading] = useState(false)
    const [dataListPool, setDataListPool] = useState([])
    // const [totalCount, setTotalCount] = useState(0)
    const [param, setParam] = useState(
        {
            page: 1,
            limit: 10,
        }
    );

    const GetListPoolLive = async () => {
        setLoading(true)
        try {
            let res = await apiLaunchPad.getPoolLive(param?.page, param?.limit);
            if (res.data.code === 200) {
                setDataListPool(res.data.data);
                // setTotalCount(res.data.total)
                setTimeout(() => {
                    setLoading(false)
                }, 1000);
            }
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    useEffect(() => {
        GetListPoolLive()
    }, [param]);

    // const onChange_Pagi = (pageNumber: any) => {
    //     setParam({
    //         ...param,
    //         page: pageNumber
    //     });
    // };

    return (
        <>
            <div className="main-page-upcoming">
                <div className="container">
                    <div className="wrap-upcoming">
                        <div className="main-title">
                            <img src="./images/title-live.png" alt="" />
                        </div>
                        <div className="project-page">
                            {loading ? (
                                <div className="spin-loading">
                                    <Spin className="w-100" size="large" indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} />
                                </div>
                            ) : dataListPool.length === 0 ? (
                                <>
                                    <div className="empty-data-opening">
                                        <img src="./images/nodata-live1.svg" alt="" />
                                    </div>
                                    <div className="empty-data-opening-mo">
                                        <img src="./images/nodata-live-mo1.svg" alt="" />
                                    </div>
                                </>

                            ) : (
                                <>
                                    {dataListPool.map((item: any, index: number) => (
                                        <Item key={index} item={item} index={index} />
                                    ))}
                                </>
                            )}

                            <br />
                            {/* {Number(totalCount) > Number(param?.limit) && (
                                <Pagination
                                    current={param.page}
                                    defaultCurrent={1}
                                    total={totalCount}
                                    pageSize={param.limit}
                                    onChange={onChange_Pagi}
                                    showSizeChanger={false}
                                    style={{ marginTop: '15px' }}
                                    className="pagiation-custom mt-15"
                                />
                            )} */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Opening